import { useEffect, useState } from 'react'

export const useWindowFocus = () => {
  const [focused, setFocused] = useState<boolean>(document.hasFocus())

  useEffect(() => {
    const onFocus = () => {
      setFocused(true)
    }
    const onBlur = () => {
      setFocused(false)
    }

    let removeFocusHandler: any, removeBlurHandler: any
    // eslint-disable-next-line
    // @ts-ignore
    const electronApi = window.api
    if (electronApi?.on) {
      removeFocusHandler = electronApi.on('browser-window-focus', onFocus)
      removeBlurHandler = electronApi.on('browser-window-blur', onBlur)
    } else {
      window.addEventListener('focus', onFocus)
      window.addEventListener('blur', onBlur)
    }
    return () => {
      if (electronApi) {
        if (removeFocusHandler) {
          removeFocusHandler()
        }
        if (removeBlurHandler) {
          removeBlurHandler()
        }
      } else {
        window.removeEventListener('focus', onFocus)
        window.removeEventListener('blur', onBlur)
      }
    }
  }, [])

  return focused
}
